import qs from "qs"
import History, {defaultContext} from "@irati/utils/history"

const removeQuery = (...queryNames) => {
  const location = {...History.location}
  const search = qs.parse(location.search.replace("?", ""))
  queryNames.forEach((q) => delete search[q])
  location.search = qs.stringify(search)

  History.push(location, defaultContext, {scrollToTop: false})
}

export default removeQuery
